import { useTranslation } from 'react-i18next';
import { cn } from '../lib/utils';

const OPTIONS: Array<{ code: 'en' | 'zh'; label: string }> = [
  { code: 'en', label: 'EN' },
  { code: 'zh', label: '中文' },
];

export function LanguageSwitcher() {
  const { i18n } = useTranslation();
  const current = i18n.language.startsWith('en') ? 'en' : 'zh';

  return (
    <div className="flex shrink-0 overflow-hidden rounded-[7px] border border-brand-border-medium text-xs">
      {OPTIONS.map((option) => (
        <button
          key={option.code}
          type="button"
          onClick={() => i18n.changeLanguage(option.code)}
          aria-pressed={current === option.code}
          className={cn(
            'cursor-pointer border-0 px-[9px] py-1 leading-5',
            current === option.code
              ? 'bg-white font-medium text-brand-text'
              : 'bg-transparent text-brand-muted hover:text-brand-text',
          )}
        >
          {option.label}
        </button>
      ))}
    </div>
  );
}
